import { UserStatus } from '@/src/lib/customer/types';
import { GetUser } from '@/src/lib/auth/types';

export function isUserRegisteredOrVerified(
  user: GetUser,
): user is GetUser & { userStatus: UserStatus.REGISTERED | UserStatus.VERIFIED } {
  return [UserStatus.REGISTERED, UserStatus.VERIFIED].includes(user.userStatus);
}

export function isUserVerified(user: GetUser): user is GetUser & { userStatus: UserStatus.VERIFIED } {
  return user.userStatus === UserStatus.VERIFIED;
}

export function isUserGuest(user: GetUser): user is GetUser & { userStatus: UserStatus.GUEST } {
  return user.userStatus === UserStatus.GUEST;
}

export function isUserUnregistered(user: GetUser): user is GetUser & { userStatus: UserStatus.UNREGISTERED } {
  return user.userStatus === UserStatus.UNREGISTERED;
}

export function isUserRegistered(user: GetUser): user is GetUser & { userStatus: UserStatus.REGISTERED } {
  return user.userStatus === UserStatus.REGISTERED;
}
